export default [
  { id: 'convencion', label: 'Convención Constitucional' },
  { id: 'otro', label: 'Otro' }
];
